
import React, { useState, useEffect, useRef } from 'react';

const Jump: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [score, setScore] = useState(0);

  useEffect(() => {
    const canvas = canvasRef.current!;
    const ctx = canvas.getContext('2d')!;
    let playerY = 300, velocity = 0, gravity = 0.5;
    let platforms = [{ x: 100, y: 350, w: 100 }, { x: 250, y: 250, w: 100 }, { x: 50, y: 150, w: 100 }];
    
    const loop = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      velocity += gravity;
      playerY += velocity;

      ctx.fillStyle = '#3b82f6';
      ctx.fillRect(180, playerY, 40, 40);

      ctx.fillStyle = '#475569';
      platforms.forEach(p => {
        ctx.fillRect(p.x, p.y, p.w, 10);
        if (velocity > 0 && playerY + 40 > p.y && playerY + 40 < p.y + 15 && 180 + 40 > p.x && 180 < p.x + p.w) {
          velocity = -12;
          setScore(s => s + 1);
        }
        p.y += 2;
        if (p.y > canvas.height) {
          p.y = 0; p.x = Math.random() * (canvas.width - 100);
        }
      });

      if (playerY > canvas.height) playerY = 0;
      requestAnimationFrame(loop);
    };
    loop();
  }, []);

  return (
    <div className="flex flex-col items-center">
      <div className="mb-4 text-xl font-bold">TICKS: {score}</div>
      <canvas ref={canvasRef} width={400} height={500} className="bg-slate-900 border-4 border-slate-800 rounded-3xl shadow-xl" />
    </div>
  );
};

export default Jump;
